import { Component, inject, Input, OnInit } from '@angular/core';
import {
  FacetCodes,
  SizeFacets,
} from '@app/custom/features/rrs-product-listing/model';
import { RrsFacetService } from '@app/custom/features/rrs-product-listing/services/rrs-facet-service/rrs-facet.service';
import { RrsProductFacetService } from '@app/custom/features/rrs-product-listing/services/rrs-product-facet-service.service';
import { AutoUnsubscribe } from '@app/shared/decorators';
import { TranslationService, RoutingService } from '@spartacus/core';
import { ActiveFacetsComponent } from '@spartacus/storefront';
import { remove } from 'lodash';
import { Subscription } from 'rxjs';

@AutoUnsubscribe()
@Component({
  selector: 'rrs-dialog-active-facets',
  templateUrl: './rrs-dialog-active-facets.component.html',
  styleUrls: ['./rrs-dialog-active-facets.component.scss'],
})
export class RrsDialogActiveFacetsComponent
  extends ActiveFacetsComponent
  implements OnInit
{
  @Input() isDialog = false;
  facetCodes = FacetCodes;
  translateService = inject(TranslationService);
  mobileSelectedFacetData$ = this.facetService.mobileDialogSelectedFacets$;
  mobileSelectedFacetData: any = {};

  subscriptions = new Subscription();

  constructor(
    protected facetService: RrsFacetService,
    protected productFacetService: RrsProductFacetService,
    protected routingService: RoutingService
  ) {
    super(facetService);
  }
  ngOnInit(): void {
    this.facetService.initialMobileFacets();
    this.subscriptions.add(
      this.mobileSelectedFacetData$.subscribe((res) => {
        this.mobileSelectedFacetData = res;
      })
    );
  }

  getTranslationKey(facetName: string): string {
    return this.facetService.getTranslationKey(facetName);
  }
  removeFromMobileSelectedFacet(key: any, val: any): void {
    remove(this.mobileSelectedFacetData[key], (res) => {
      return res == val;
    });
    this.facetService.mobileDialogSelectedFacets$.next(
      this.mobileSelectedFacetData
    );
  }

  isSizeFacet(value: any): boolean {
    return SizeFacets.includes(value.key as FacetCodes);
  }
}
